module.exports = __webpack_public_path__ + "media/images/client_logos/logo_seloger_200-13bbc4481585394d3d8bc920a4e54a73.png";